import axios from "axios"
import { Formik } from "formik"
import React, { useEffect, useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap"

const ViewRD6Report = ({
  viewToggle,
  selectedItem,
  userPermissions,
  setAuth,
  editing,
  setEditing,
  cleanReport,
}) => {
  // console.log("selectedItem", selectedItem)
  // console.log("cleanReport", cleanReport)
  const [declaration, setDeclaration] = useState("")
  const [modal, setModal] = useState(true)
  const toggle = () => {
    viewToggle()
  }

  const onClose = () => {
    viewToggle()
  }

  const history = useHistory()

  const statusOptions =
    userPermissions.R2.G === "1" || userPermissions.R4.G === "1"
      ? [
          { value: "InProgress", label: "InProgress" },
          { value: "Hold", label: "Hold" },
          { value: "Completed", label: "Completed" },
          { value: "Approved", label: "Approved" },
          { value: "Rejected", label: "Rejected" },
          { value: "Uploaded", label: "Uploaded" },
          { value: "Unuploaded", label: "Unuploaded" },
        ]
      : [
          { value: "", label: "Select Status ..." },
          { value: "Hold", label: "Hold" },
          { value: "Approved", label: "Approved" },
          { value: "Rejected", label: "Rejected" },
        ]

  const validateHandler = values => {
    let errors = {}

    //status error
    if (!values.status) errors.status = "required"

    //description error
    if (
      (values.status === "Rejected" || values.status === "Hold") &&
      !values.description
    )
      errors.description = "required"

    //reject reason error
    if (
      (selectedItem.DesStatus === "Approved" ||
        selectedItem.InsStatus === "Approved") &&
      (userPermissions.R20.P === "2" ||
        userPermissions.R20.P === "3" ||
        userPermissions.R20.P === "4") &&
      values.status === "Rejected" &&
      !values.rejectReason
    ) {
      errors.rejectReason = "required"
    }

    console.log("values", values)
    console.log("errors", errors)

    return errors
  }

  const submitHandler = values => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      RD6ID: selectedItem.RD6ID,
    }
    if (values.status === "Rejected" || values.status === "Hold")
      formData.Description = values.description

    // for Design subcontractor ************
    if (
      selectedItem.DesReport === true &&
      selectedItem.SubContractor === true &&
      (userPermissions.R22.P === "2" ||
        userPermissions.R22.P === "3" ||
        userPermissions.R22.P === "4" ||
        userPermissions.R22.G === "1")
    )
      formData.QCStatus = values.status

    // for Design supervisor ************
    if (
      selectedItem.DesReport === true &&
      (userPermissions.R1.G === "1" || userPermissions.R3.G === "1") &&
      (userPermissions.R22.P !== "2" ||
        userPermissions.R22.P !== "3" ||
        userPermissions.R22.P !== "4" ||
        userPermissions.R22.G !== "1")
    )
      formData.DesStatus = values.status

    // for Inspection supervisor ************
    if (
      selectedItem.InsReport === true &&
      selectedItem.AreaManagerID === localStorage.getItem("id")
    )
      formData.InsStatus = values.status

    // for Inspection Review Engineer ************
    if (
      (selectedItem.DesStatus === "Approved" ||
        selectedItem.InsStatus === "Approved") &&
      (userPermissions.R20.P === "2" ||
        userPermissions.R20.P === "3" ||
        userPermissions.R20.P === "4")
    ) {
      formData.InsrevStatus = values.status
      if (values.status === "Rejected") formData.InsrevTo = values.rejectReason
    }

    // for Inspection Department Manager ************
    if (
      selectedItem.InsrevStatus === "Approved" &&
      (userPermissions.R2.G === "1" || userPermissions.R4.G === "1")
    )
      formData.Status = values.status

    // console.log("formData", formData)

    axios
      .post(process.env.REACT_APP_API_URL + "api/RD6/EditRD6.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        setEditing(!editing)
      })
      .catch(err => console.log(err))

    onClose()
  }

  const [RD6HistoryList, setRD6HistoryList] = useState([])
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      RD6ID: selectedItem.RD6ID,
    }

    axios
      .post(process.env.REACT_APP_API_URL + "api/RD6/RD6History.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res.data)
        let array = Object.values(res.data)
        array.splice(-1)
        setRD6HistoryList(array)
      })
      .catch(err => console.log(err))
  }, [])

  // ******************** Initial Status *******************************
  // let initialStatus = ""
  // useEffect(() => {
  //   // for Design supervisor
  //   if (
  //     selectedItem.DesReport === true &&
  //     (userPermissions.R1.G === "1" || userPermissions.R3.G === "1")
  //   )
  //     initialStatus = selectedItem.DesStatus

  //   // for Inspection supervisor
  //   if (
  //     selectedItem.InsReport === true &&
  //     selectedItem.AreaManagerID === localStorage.getItem("id")
  //   )
  //     initialStatus = selectedItem.InsStatus

  //   // for Inspection Review Engineer
  //   if (
  //     (selectedItem.DesStatus === "Approved" ||
  //       selectedItem.InsStatus === "Approved") &&
  //     (userPermissions.R20.P === "2" ||
  //       userPermissions.R20.P === "3" ||
  //       userPermissions.R20.P === "4")
  //   )
  //     initialStatus = selectedItem.InsrevStatus

  //   // for Inspection Department Manager
  //   if (
  //     selectedItem.InsrevStatus === "Approved" &&
  //     (userPermissions.R2.G === "1" || userPermissions.R4.G === "1")
  //   )
  //     initialStatus = selectedItem.ReportStatus
  // }, [selectedItem])
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: selectedItem.ProjectID,
    }
    axios
      .post(process.env.REACT_APP_API_URL + `api/Declaration.php`, formData)
      .then(res => {
        setDeclaration(res.data.Declaration)
      })
      .catch(err => console.log(err))
  }, [])
  console.log("selectedItem.AreaManagerID", selectedItem.AreaManagerID)
  console.log("declaration", declaration)
  return (
    <div>
      <Modal className="modal-xl" isOpen={modal} toggle={toggle}>
        <ModalHeader>
          View RD-6 Report
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={onClose}
          />
        </ModalHeader>
        <ModalBody>
          <Tabs className="mb-5" justify fill>
            <Tab eventKey="report" title="RD-6 Report">
              <Table bordered>
                <tbody>
                  <tr>
                    <th>Category</th>
                    <td>
                      <i
                        className={
                          selectedItem.Category === "Residential"
                            ? "fas fa-home"
                            : selectedItem.Category === "Hotels"
                            ? "fas fa-hotel"
                            : selectedItem.Category === "less than 23 meters"
                            ? "fas fa-building"
                            : selectedItem.Category === "Commercial Centers"
                            ? "fas fa-store"
                            : selectedItem.Category === "Entertainment Services"
                            ? "fas fa-skating"
                            : selectedItem.Category === "High Rise Towers"
                            ? "fas fa-building"
                            : selectedItem.Category === "High risk buildings"
                            ? "fas fa-building"
                            : selectedItem.Category === "Motels"
                            ? "fas fa-hotel"
                            : selectedItem.Category === "Educational"
                            ? "fas fa-school"
                            : selectedItem.Category ===
                              "Gathering buildings Mosques"
                            ? "fas fa-mosque"
                            : selectedItem.Category ===
                              "Business Buildings (Airports, Banks, TV Stations Post Offices)"
                            ? "fas fa-building"
                            : selectedItem.Category ===
                              "Gathering buildings Sports Premises"
                            ? "fas fa-running"
                            : selectedItem.Category === "Warehouses"
                            ? "fas fa-warehouse"
                            : selectedItem.Category === "Industrial"
                            ? "fas fa-industry"
                            : selectedItem.Category ===
                              "Furnished Hotel Apartments"
                            ? "fas fa-hotel"
                            : selectedItem.Category ===
                              "Gathering buildings Wedding Halls Cinemas Theaters"
                            ? "fas fa-warehouse"
                            : selectedItem.Category === "Hospitals"
                            ? "fas fa-hospital-alt"
                            : selectedItem.Category === "Healthcare Centers"
                            ? "fas fa-hospital"
                            : selectedItem.Category ===
                              "Telecommunication Towers"
                            ? "fas fa-broadcast-tower"
                            : "fas fa-building"
                        }
                        id="categorytooltip"
                      />
                      <UncontrolledTooltip
                        placement="right"
                        target="categorytooltip"
                      >
                        {selectedItem.Category || "N/A"}
                      </UncontrolledTooltip>
                    </td>
                    <th>Owner</th>
                    <td>{selectedItem.OwnerName}</td>
                  </tr>

                  <tr>
                    <th>Reference No</th>
                    <td>{selectedItem.ReferenceNo}</td>
                    <th>Contractor</th>
                    <td>{selectedItem.ConstructorName}</td>
                  </tr>

                  <tr>
                    <th>Type</th>
                    <td>{selectedItem.Type}</td>
                    <th>Status</th>
                    <td>{selectedItem.Status}</td>
                  </tr>

                  <tr>
                    <th>Designer</th>
                    <td>{selectedItem.DesignName}</td>
                    <th>Inspector</th>
                    <td>{selectedItem.InspectionName}</td>
                  </tr>

                  <tr>
                    <th>Design Manager</th>
                    <td>{selectedItem.DesMangerName}</td>
                    <th>Area Manager</th>
                    <td>{selectedItem.AreaManagerName}</td>
                  </tr>
                </tbody>
              </Table>

              <Formik
                initialValues={{
                  // status: initialStatus,
                  description: "",
                  // description: selectedItem.Description,
                }}
                validate={validateHandler}
                onSubmit={submitHandler}
              >
                {props => (
                  <Form className="ms-1" onSubmit={props.handleSubmit}>
                    {
                      //for design subcontractor
                      (userPermissions.R22.P === "2" ||
                        userPermissions.R22.P === "3" ||
                        userPermissions.R22.P === "4" ||
                        userPermissions.R22.G === "1" ||
                        //for design supervisor
                        userPermissions.R1.G === "1" ||
                        userPermissions.R3.G === "1" ||
                        // for inspection supervisor
                        selectedItem.AreaManagerID ===
                          localStorage.getItem("id") ||
                        // for Inspection Review Engineer
                        userPermissions.R20.P === "2" ||
                        userPermissions.R20.P === "3" ||
                        userPermissions.R20.P === "4" ||
                        // for Inspection Department Manager
                        userPermissions.R2.G === "1" ||
                        userPermissions.R4.G === "1") && (
                        <>
                          {/* ************************* Report Status ************************** */}
                          <Row className="mt-5">
                            <Col sm={3} className="d-flex align-items-center">
                              <Label htmlFor="report-status">
                                Change status of report {selectedItem.StageName}
                              </Label>
                            </Col>
                            <Col sm={4}>
                              <Input
                                type="select"
                                name="status"
                                id="report-status"
                                onChange={props.handleChange}
                                className="form-control border-dark"
                                disabled={
                                  //for design subcontractor
                                  ((userPermissions.R22.P === "2" ||
                                    userPermissions.R22.P === "3" ||
                                    userPermissions.R22.P === "4" ||
                                    userPermissions.R22.G === "1") &&
                                    (selectedItem.SubContractor === false ||
                                      selectedItem.DesReport === false ||
                                      selectedItem.QCStatus === "Approved")) ||
                                  //for design supervisor
                                  ((userPermissions.R1.G === "1" ||
                                    userPermissions.R3.G === "1") &&
                                    (selectedItem.DesReport === false ||
                                      selectedItem.DesStatus === "Approved")) ||
                                  // for inspection supervisor
                                  (selectedItem.AreaManagerID ===
                                    localStorage.getItem("id") &&
                                    (selectedItem.InsReport === false ||
                                      selectedItem.InsStatus === "Approved")) ||
                                  // for Inspection Review Engineer
                                  ((userPermissions.R20.P === "2" ||
                                    userPermissions.R20.P === "3" ||
                                    userPermissions.R20.P === "4") &&
                                    ((selectedItem.DesStatus !== "Approved" &&
                                      selectedItem.InsStatus !== "Approved") ||
                                      selectedItem.InsrevStatus ===
                                        "Approved")) ||
                                  // for Inspection Department Manager
                                  ((userPermissions.R2.G === "1" ||
                                    userPermissions.R4.G === "1") &&
                                    (selectedItem.InsrevStatus !== "Approved" ||
                                      selectedItem.Status === "Uploaded"))
                                }
                              >
                                {statusOptions.map((status, i) => (
                                  <option
                                    key={i}
                                    value={status.value}
                                    selected={
                                      selectedItem.Status === status.value
                                    }
                                  >
                                    {status.label}
                                  </option>
                                ))}
                              </Input>
                            </Col>
                          </Row>

                          {/* *************** Rejection Reason for inspection Review Engineer ****************** */}
                          {(selectedItem.DesStatus === "Approved" ||
                            selectedItem.InsStatus === "Approved") &&
                            (userPermissions.R20.P === "2" ||
                              userPermissions.R20.P === "3" ||
                              userPermissions.R20.P === "4") &&
                            props.values.status === "Rejected" && (
                              <Row className="mt-5">
                                <Col
                                  sm={3}
                                  className="d-flex align-items-center"
                                >
                                  <Label htmlFor="report-status">
                                    Rejection Department
                                  </Label>
                                </Col>
                                <Col sm={4}>
                                  <Input
                                    type="select"
                                    name="rejectReason"
                                    id="rejectReason"
                                    onChange={props.handleChange}
                                    className="form-control border-dark"
                                  >
                                    <option value="">Select Reason ...</option>
                                    <option value="Des">Design Report</option>
                                    <option value="Ins">
                                      Inspection Report
                                    </option>
                                  </Input>
                                  {props.errors.rejectReason ? (
                                    <p className="error mx-2 d-flex justify-content-end">
                                      {props.errors.rejectReason}
                                    </p>
                                  ) : null}
                                </Col>
                              </Row>
                            )}

                          {/* ************************* Description textarea ************************** */}
                          {(props.values.status === "Rejected" ||
                            props.values.status === "Hold") && (
                            <Row className="mt-4">
                              <Col sm={3} className="d-flex align-items-center">
                                <Label htmlFor="report-status">
                                  Description
                                </Label>
                              </Col>
                              <Col>
                                <Input
                                  type="textarea"
                                  name="description"
                                  id="report-description"
                                  value={props.values.description}
                                  onChange={props.handleChange}
                                  className="form-control border-dark"
                                />

                                {props.errors.description ? (
                                  <p className="error mx-2 d-flex justify-content-end">
                                    {props.errors.description}
                                  </p>
                                ) : null}
                              </Col>
                            </Row>
                          )}
                        </>
                      )
                    }

                    <FormGroup className="d-flex ms-auto  mt-5 justify-content-between">
                      <div className="col-7 d-flex  justify-content-start">
                        {
                          <>
                            {/* {selectedItem.InsReport === true &&
                              (userPermissions.R20.P !== 0 ||
                                userPermissions.R20.G === 1 ||
                                userPermissions.R2.G === 1 ||
                                userPermissions.R4.G === 1) && (
                                <a
                                  href={selectedItem.Link}
                                  className="mx-2"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-label"
                                  >
                                    Export RD6
                                    <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                                  </button>
                                </a>
                              )} */}

                            {/* {selectedItem.DesReport === true &&
                              (userPermissions.R20.P !== 0 ||
                                userPermissions.R20.G === 1 ||
                                userPermissions.R2.G === 1 ||
                                userPermissions.R4.G === 1) && (
                                <a
                                  href={selectedItem.RD3Link}
                                  className="mx-2"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-label"
                                  >
                                    Export RD3
                                    <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                                  </button>
                                </a>
                              )} */}

                            {selectedItem.Link &&
                              (userPermissions.R20.P !== 0 ||
                                userPermissions.R20.G === 1 ||
                                userPermissions.R2.G === 1 ||
                                userPermissions.R4.G === 1) && (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-label mx-2"
                                  onClick={e => {
                                    window.open(selectedItem.Link)
                                  }}
                                  disabled={
                                    !selectedItem.InsReport &&
                                    !selectedItem.DesReport
                                  }
                                >
                                  Export RD6
                                  <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                                </button>
                              )}
                            {selectedItem.RD3Link &&
                              (userPermissions.R20.P !== 0 ||
                                userPermissions.R20.G === 1 ||
                                userPermissions.R2.G === 1 ||
                                userPermissions.R4.G === 1) && (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-label mx-2"
                                  onClick={e => {
                                    window.open(selectedItem.RD3Link)
                                  }}
                                  disabled={!selectedItem.InsReport}
                                >
                                  Export RD3
                                  <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                                </button>
                              )}
                          </>
                        }

                        {/* {selectedItem.TicketNum * 1 > 0 ||
                        !selectedItem.PStageID ||
                        ((selectedItem.DesReport === false ||
                          selectedItem.InsReport === false) &&
                          userPermissions.R20.P === 0) ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-label mx-2"
                            disabled
                          >
                            Export Word
                            <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                          </button>
                        ) : userPermissions.R20.P !== 0 ||
                          userPermissions.R20.G === 1 ||
                          userPermissions.R2.G === 1 ||
                          userPermissions.R4.G === 1 ? (
                          <>
                            <a
                              // href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6.php?PStageID=${selectedItem.PStageID}`}
                              href={selectedItem.Link}
                              className="mx-2"
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <button
                                type="button"
                                className="btn btn-primary btn-label"
                              >
                                Export RD6
                                <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                              </button>
                            </a>

                            {selectedItem.RD3Link && (
                              <a
                                // href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6.php?PStageID=${selectedItem.PStageID}`}
                                href={selectedItem.RD3Link}
                                className="mx-2"
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary btn-label"
                                >
                                  Export RD3
                                  <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                                </button>
                              </a>
                            )}
                          </>
                        ) : cleanReport === true ? (
                          <UncontrolledDropdown className="btn-group bg-primary d-flex align-items-center">
                            <a
                              href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6c.php?PStageID=${selectedItem.PStageID}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <button
                                type="button"
                                className="btn btn-primary btn-label"
                              >
                                Export Clean Word
                                <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                              </button>
                            </a>
                            <DropdownToggle
                              tag="a"
                              to="#"
                              className="card-drop"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="mdi mdi-dots-horizontal font-size-18 text-light me-1"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <DropdownItem>
                                <a
                                  href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6r.php?PStageID=${selectedItem.PStageID}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download
                                >
                                  Export Risk Assesment
                                </a>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        ) : (
                          <UncontrolledDropdown className="btn-group bg-primary d-flex align-items-center">
                            <a
                              href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6.php?PStageID=${selectedItem.PStageID}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <button
                                type="button"
                                className="btn btn-primary btn-label"
                              >
                                Export Full Word
                                <i className="mdi mdi-file-word-outline ms-1 label-icon"></i>
                              </button>
                            </a>
                            <DropdownToggle
                              tag="a"
                              to="#"
                              className="card-drop"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="mdi mdi-dots-horizontal font-size-18 text-light me-1"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <DropdownItem>
                                <a
                                  href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6c.php?PStageID=${selectedItem.PStageID}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download
                                >
                                  Export Clean Report
                                </a>
                              </DropdownItem>
                              <DropdownItem>
                                <a
                                  href={`${process.env.REACT_APP_API_URL}wordlib/vendor/phpoffice/phpword/samples/rd6r.php?PStageID=${selectedItem.PStageID}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  download
                                >
                                  Export Risk Assesment
                                </a>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        )} */}

                        <Button
                          className="bg-primary mx-2"
                          onClick={() => {
                            if (selectedItem.TicketNum * 1 > 0) {
                              // history.push(
                              //   `/rd-6/${selectedItem.ProjectID}/tickets`
                              // )
                              declaration
                                ? history.push(
                                    `/rd-6/${selectedItem.ProjectID}/tickets`
                                  )
                                : history.push(
                                    `/PrivacyATerms/${selectedItem.ProjectID}`,
                                    {
                                      data: selectedItem,
                                      from: "RD6",
                                      to: `/rd-6/${selectedItem.ProjectID}/tickets`,
                                    }
                                  )
                            } else {
                              if (
                                userPermissions.R4.P === "1" ||
                                userPermissions.R4.P === "2" ||
                                userPermissions.R4.P === "3" ||
                                userPermissions.R4.P === "4" ||
                                userPermissions.R4.G === "1"
                              ) {
                                declaration
                                  ? history.push(
                                      `/rd-6/${selectedItem.ProjectID}/visits`
                                    )
                                  : history.push(
                                      `/PrivacyATerms/${selectedItem.ProjectID}`,
                                      {
                                        data: selectedItem,
                                        from: "RD6",
                                        to: `/rd-6/${selectedItem.ProjectID}/visits`,
                                      }
                                    )
                                // history.push(
                                //   `/rd-6/${selectedItem.ProjectID}/visits`
                                // )
                              } else {
                                // history.push(`/rd-6/${selectedItem.ProjectID}`)
                                declaration
                                  ? history.push(
                                      `/rd-6/${selectedItem.ProjectID}`
                                    )
                                  : history.push(
                                      `/PrivacyATerms/${selectedItem.ProjectID}`,
                                      {
                                        data: selectedItem,
                                        from: "RD6",
                                        to: `/rd-6/${selectedItem.ProjectID}`,
                                      }
                                    )
                              }
                            }
                          }}
                          disabled={
                            //for designer
                            (selectedItem.DesStatus === "Approved" &&
                              (userPermissions.R1.G !== "1" ||
                                userPermissions.R3.G !== "1") &&
                              (userPermissions.R3.P === "2" ||
                                userPermissions.R3.P === "3" ||
                                userPermissions.R3.P === "4")) ||
                            //for inspector
                            (selectedItem.InsStatus === "Approved" &&
                              (userPermissions.R2.G !== "1" ||
                                userPermissions.R4.G !== "1") &&
                              (userPermissions.R4.P === "2" ||
                                userPermissions.R4.P === "3" ||
                                userPermissions.R4.P === "4") &&
                              userPermissions.R20.P !== "2" &&
                              userPermissions.R20.P !== "3" &&
                              userPermissions.R20.P !== "4") ||
                            //for design subcontractor
                            ((userPermissions.R22.P === "2" ||
                              userPermissions.R22.P === "3" ||
                              userPermissions.R22.P === "4" ||
                              userPermissions.R22.G === "1") &&
                              (selectedItem.SubContractor === false ||
                                selectedItem.DesReport === false ||
                                selectedItem.QCStatus === "Approved")) ||
                            //for design supervisor
                            ((userPermissions.R1.G === "1" ||
                              userPermissions.R3.G === "1") &&
                              (selectedItem.DesReport === false ||
                                selectedItem.DesStatus === "Approved")) ||
                            // for inspection supervisor
                            (selectedItem.AreaManagerID ===
                              localStorage.getItem("id") &&
                              // and inspector
                              ((selectedItem.InsUserID ===
                                localStorage.getItem("id") &&
                                selectedItem.InsStatus === "Approved") ||
                                // and not inspector
                                (selectedItem.InsUserID !==
                                  localStorage.getItem("id") &&
                                  (selectedItem.InsReport === false ||
                                    selectedItem.InsStatus === "Approved")))) ||
                            // (selectedItem.AreaManagerID ===
                            //   localStorage.getItem("id") &&
                            //   (selectedItem.InsReport === false ||
                            //     selectedItem.InsStatus === "Approved")) ||

                            // for Inspection Review Engineer
                            ((userPermissions.R20.P === "2" ||
                              userPermissions.R20.P === "3" ||
                              userPermissions.R20.P === "4") &&
                              ((selectedItem.DesStatus !== "Approved" &&
                                selectedItem.InsStatus !== "Approved") ||
                                selectedItem.InsrevStatus === "Approved")) ||
                            // for Inspection Department Manager
                            ((userPermissions.R2.G === "1" ||
                              userPermissions.R4.G === "1") &&
                              (selectedItem.InsrevStatus !== "Approved" ||
                                selectedItem.Status === "Uploaded"))
                          }
                        >
                          OverView RD6
                        </Button>

                        {selectedItem.udr && (
                          <Button
                            className="bg-primary mx-2"
                            onClick={() =>
                              window.open(selectedItem.udr, "_blank")
                            }
                            disabled={!selectedItem.InsReport}
                          >
                            Unified Baladi Report
                          </Button>
                        )}
                      </div>

                      {(userPermissions.R22.P === "2" ||
                        userPermissions.R22.P === "3" ||
                        userPermissions.R22.P === "4" ||
                        userPermissions.R22.G === "1" ||
                        userPermissions.R1.G === "1" ||
                        userPermissions.R3.G === "1" ||
                        selectedItem.AreaManagerID ===
                          localStorage.getItem("id") ||
                        userPermissions.R20.P === "2" ||
                        userPermissions.R20.P === "3" ||
                        userPermissions.R20.P === "4" ||
                        userPermissions.R2.G === "1" ||
                        userPermissions.R4.G === "1") && (
                        <Button
                          type="submit"
                          className="bg-primary"
                          disabled={
                            //for design subcontractor
                            ((userPermissions.R22.P === "2" ||
                              userPermissions.R22.P === "3" ||
                              userPermissions.R22.P === "4" ||
                              userPermissions.R22.G === "1") &&
                              (selectedItem.SubContractor === false ||
                                selectedItem.DesReport === false ||
                                selectedItem.QCStatus === "Approved")) ||
                            //for design supervisor
                            ((userPermissions.R1.G === "1" ||
                              userPermissions.R3.G === "1") &&
                              (selectedItem.DesReport === false ||
                                selectedItem.DesStatus === "Approved")) ||
                            // for inspection supervisor
                            (selectedItem.AreaManagerID ===
                              localStorage.getItem("id") &&
                              (selectedItem.InsReport === false ||
                                selectedItem.InsStatus === "Approved")) ||
                            // for Inspection Review Engineer
                            ((userPermissions.R20.P === "2" ||
                              userPermissions.R20.P === "3" ||
                              userPermissions.R20.P === "4") &&
                              ((selectedItem.DesStatus !== "Approved" &&
                                selectedItem.InsStatus !== "Approved") ||
                                selectedItem.InsrevStatus === "Approved")) ||
                            // for Inspection Department Manager
                            ((userPermissions.R2.G === "1" ||
                              userPermissions.R4.G === "1") &&
                              (selectedItem.InsrevStatus !== "Approved" ||
                                selectedItem.Status === "Uploaded"))
                          }
                        >
                          Submit
                        </Button>
                      )}
                    </FormGroup>
                  </Form>
                )}
              </Formik>
            </Tab>

            <Tab eventKey="history" title="RD6 History">
              <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
                <Table className="text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Updater</th>
                      <th>Action</th>
                      <th>Description</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {RD6HistoryList.map((item, i) => (
                      <tr key={i}>
                        <th scope="row">{i + 1}</th>
                        <td>{item.UpdaterName}</td>
                        <td>{item.Action || "-"}</td>
                        <td>{item.Description || "-"}</td>
                        <td>{item.CreatedAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Tab>
          </Tabs>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ViewRD6Report
